import { Component, CUSTOM_ELEMENTS_SCHEMA, OnInit } from '@angular/core';
import { RouterLink, RouterOutlet } from '@angular/router';
import { AgentsService } from '@app/services/agents.service';
import { SharedService } from '@app/services/shared.service';

@Component({
  selector: 'blu-agents',
  templateUrl: './agents.component.html',
  styleUrls: ['./agents.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  standalone: true,
  imports: [RouterLink, RouterOutlet],
})
export class AgentsComponent implements OnInit {
  constructor(
    public agentsService: AgentsService,
    public sharedService: SharedService,
  ) {}

  ngOnInit(): void {
    if (!this.agentsService.agents.length) this.agentsService.getAgents();
  }
}
